<template>
  <div v-show="isShow.isPVShow" class="pg5">
    <Nav @nav="handleNav" :activeNum="5" />
    <div class="pg5-title"></div>
    <div class="pg5-article-title1">
      <img src="./img/pg5-article-title1-inner.png" alt="">
    </div>
    <div class="pg5-article1">
      <div class="pg5-article1-part1">
        <div class="pg5-article1-text1"></div>
        <div class="pg5-article1-h5">
          <a href="https://file04aee8df0273.aiwall.com/v3/idea/f3hwfhhn"></a>
        </div>
      </div>
      <div class="pg5-article1-text2"></div>
      <div class="pg5-article-sub"></div>
      <div class="pg5-article1-content" ref="content">
        <div class="pg5-fig3-left">
          <div class="pg5-l1"></div>
          <div class="pg5-l2"></div>
          <div class="pg5-l3"></div>
        </div>
        <div class="pg5-fig3-mid">
          <div class="pg5-m1">
            <div class="m-arrow1 m-arrow-l m-arrow-l1"></div>
          </div>
          <div class="pg5-m2">
            <div class="m-arrow2 m-arrow-r m-arrow-r1"></div>
          </div>
          <div class="pg5-m3">
            <div class="m-arrow3 m-arrow-l m-arrow-l1"></div>
          </div>
          <div class="pg5-m4">
            <div class="m-arrow4 m-arrow-r m-arrow-r1"></div>
          </div>
          <div class="pg5-m5">
            <div class="m-arrow5 m-arrow-l m-arrow-l1"></div>
          </div>
          <div class="pg5-m6">
            <div class="m-arrow6 m-arrow-r m-arrow-r1"></div>
          </div>
        </div>
        <div class="pg5-fig3-right">
          <div class="pg5-r1"></div>
          <div class="pg5-r2"></div>
          <div class="pg5-r3"></div>
        </div>
      </div>
      <div class="pg5-article-text3"></div>
      <div class="pg5-fig1-wp" ref="table1">
        <div class="pg5-fig1-table"></div>
        <div class="pg5-fig1-footer"></div>
      </div>
      <div class="pg5-article-text4"></div>
      <div class="pg5-fig2-wp" ref="table2">
        <div class="pg5-fig2-table"></div>
        <div class="pg5-fig2-footer"></div>
      </div>
      <div class="pg5-fig3-wp" ref="table3">
        <div class="pg5-fig3-table-wp">
          <div class="pg5-fig3-table"></div>
        </div>
        <div class="pg5-fig3-bottom"></div>
      </div>
    </div>
    <div class="pg5-article-title2">
      <img src="./img/pg5-article-title2-inner.png" alt="">
    </div>
    <div class="pg5-article2">
      <div class="pg5-article2-part">
        <div class="pg5-article2-h5">
          <a href="https://file04aee8df0273.aiwall.com/v3/idea/f3hwfhhn"></a>
        </div>
        <div class="pg5-article2-text1"></div>
      </div>
      <div class="pg5-article2-text2"></div>
      <div class="pg5-article2-text3"></div>
    </div>
    <div class="bg-bottom">
      <div class="bg-bottom-inner">
        <div class="btn-wp" @click="vote">
          <span class="icon-thumb"></span>
          <span class="btn-num">{{num}}</span>
        </div>
        <p class="btn-desc">点赞</p>
        <div class="btn-back" @click="goBack">返回</div>
      </div>
    </div>
    <toast :toastMsg="msg" :ms="time" :isTrigger="trigger" />
  </div>
</template>

<script>
import Nav from '../../components/navBar/navBar'
import { postData } from '../../assets/util'
import Toast from '../../components/toast/toast'

export default {
  name: 'PageFive',
  props: {
    isShow: Object
  },
  components: {
    Nav,
    Toast
  },
  data() {
    return {
      num: 0,
      trigger: false,
      msg: '',
      time: 1500,
    }
  },
  methods: {
    goBack() {
      setTimeout(() => {
        this.$emit('nextPage', 'isPOShow')
      }, 300)
    },
    handleNav(msg) {
      this.$emit('nextPage', msg);
    },
    notify(msg, time) {
      this.trigger = !this.trigger;
      this.msg = msg || '';
      this.time = time || 1500;
    },
    getNumber() {
      const URL = '/codes/2020/nfdw/game.php/Home/Index/JDOU_articleZan';
      const myData = {articleId: 4};
      postData(URL, myData)
        .then(res => {
          if (res.status === 1) {
            let tempNum = parseInt(res.zanNum);
            this.num = tempNum;
          } else {
            const txt = res.msg || '获取失败';
            this.notify(txt);
          }
        })
        .catch(err => {
          this.notify('获取出错')
        })
    },
    vote() {
      const URL = '/codes/2020/nfdw/game.php/Home/Index/JDOU_zan';
      const myData = {articleId: 4};
      postData(URL, myData)
        .then(res => {
          if (res.status === 1) {
            this.notify('点赞成功');
            this.num += 1;
          } else {
            const txt = res.msg || '点赞失败';
            this.notify(txt);
          }
        })
        .catch(err => {
          this.notify('点赞出错')
        })
    },
  },
  watch: {
    'isShow.isPVShow': function () {
      window.scroll(0, 0);
      const content = this.$refs.content;
      const table1 = this.$refs.table1;
      const table2 = this.$refs.table2;
      const table3 = this.$refs.table3;
      content.classList.remove('play');
      table1.classList.remove('fig1-play');
      table2.classList.remove('fig2-play');
      table3.classList.remove('fig3-play');
    }
  },
  created() {
    this.getNumber();
  },
  mounted() {
    const ele1 = document.querySelector('.pg5-article-sub');
    const content = this.$refs.content;
    const table1 = this.$refs.table1;
    const table2 = this.$refs.table2;
    const table3 = this.$refs.table3;
    window.addEventListener('scroll', () => {
      if (this.isShow.isPVShow) {
        const dis = ele1.getBoundingClientRect().top;
        if (dis < 380) {
          content.classList.add('play');
        }
        if (dis < -380) {
          table1.classList.add('fig1-play');
        }
        if (dis < -600) {
          table2.classList.add('fig2-play')
        }
        if (dis < -620) {
          table3.classList.add('fig3-play');
        }
      }
    })
  }
}
</script>

<style lang="less" scoped>
.bg(@url) {
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url(@url);
}
.pg5 {
  box-sizing: border-box;
  padding-top: 1.9375rem /* 31/16 */;
  min-height: 100vh;
  background-color: #012bad;
}
.pg5-title {
  width: 23.4375rem /* 375/16 */;
  height: 21.25/2rem /* 340/16 */;
  .bg('./img/pg5-title.png');
}
.pg5-article-title1 {
  margin: 0 auto;
  margin-bottom: .625rem /* 10/16 */;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 18.6875/2.2rem /* 299/16 */;
    height: 2.625/2.2rem /* 42/16 */;
  }
}
.pg5-article1 {
  margin: 0 auto;
  width: 42.75/2rem /* 684/16 */;
  height: 244.625/2rem /* 3914/16 */;
  padding-top: 2.25rem /* 36/16 */;
  .bg('./img/pg5-article-bg.png');
  overflow: hidden;
}
.pg5-article1-part1 {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 1.25rem /* 20/16 */ 0 1.625rem /* 26/16 */;
}
.pg5-article1-text1 {
  width: 18.3125/2rem /* 293/16 */;
  height: 13.125rem /* 210/16 */;
  margin-top: 1.25rem /* 20/16 */;
  .bg('./img/pg5-article-text1.png');
}
.pg5-article1-h5 {
  width: 17.875/2rem /* 286/16 */;
  height: 30.25/2rem /* 484/16 */;
  .bg('./img/h5-1.png');
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.pg5-article1-text2 {
  margin: 0 auto;
  margin-top: .625rem /* 10/16 */;
  width: 36.0625/2rem /* 577/16 */;
  height: 9.75/2rem /* 156/16 */;
  .bg('./img/pg5-article-text2.png');
}
.pg5-article-sub {
  margin: 1.5rem /* 24/16 */ auto;
  width: 23.625/2rem /* 378/16 */;
  height: 4.875/2rem /* 78/16 */;
  .bg('./img/pg5-inner-title.png');
}
.pg5-article1-content {
  display: flex;
  margin: 0 auto;
  width: 38.75/2rem /* 620/16 */;
  height: 46.4375/2rem /* 743/16 */;
  opacity: 0;
}
.pg5-l1 {
  width: 10.5625/2rem /* 169/16 */;
  height: 8.125/2rem /* 130/16 */;
  margin-top: 1.5rem /* 24/16 */;
  margin-left: 1.625rem /* 26/16 */;
  .bg('./img/pg5-left1.png');
}
.pg5-l2 {
  width: 12.8125/2rem /* 205/16 */;
  height: 9.625/2rem /* 154/16 */;
  margin-top: 1.625rem /* 26/16 */;
  margin-left: .625rem /* 10/16 */;
  .bg('./img/pg5-left2.png');
}
.pg5-l3 {
  width: 13.875/2rem /* 222/16 */;
  height: 12.8125/2rem /* 205/16 */;
  margin-top: 1.125rem /* 18/16 */;
  .bg('./img/pg5-left3.png');
}
.pg5-fig3-mid {
  box-sizing: border-box;
  padding: 0 1.25rem /* 20/16 */;
  flex-basis: 8.4375rem /* 135/16 */;
}
.pg5-m1 {
  position: relative;
  width: 5.0625/2rem /* 81/16 */;
  height: 7.1875/2rem /* 115/16 */;
  margin-left: .625rem /* 10/16 */;
  z-index: 6;
  .bg('./img/pg5-mid1.png');
}
.m-arrow-l1 {
  position: absolute;
  top: 1.5rem /* 24/16 */;
  left: -1.25rem /* 20/16 */;
}
.m-arrow-l {
  width: 3.0625/2rem /* 49/16 */;
  height: .4375/2rem /* 7/16 */;
  .bg('./img/pg5-arrow-left.png')
}
.m-arrow-r1 {
  position: absolute;
  top: 1.5rem /* 24/16 */;
  right: -1.4375rem /* 23/16 */;
}
.m-arrow-r {
  width: 3.0625/2rem /* 49/16 */;
  height: .4375/2rem /* 7/16 */;
  .bg('./img/pg5-arrow-right.png');
}
.pg5-m2 {
  position: relative;
  width: 4.9375/2rem /* 79/16 */;
  height: 7/2rem /* 112/16 */;
  .bg('./img/pg5-mid2.png');
  z-index: 5;
  margin-top: -.625rem /* 10/16 */;
}
.pg5-m3 {
  position: relative;
  width: 5.0625/2rem /* 81/16 */;
  height: 7.1875/2rem /* 115/16 */;
  margin-left: .625rem /* 10/16 */;
  margin-top: -.625rem /* 10/16 */;
  z-index: 4;
  .bg('./img/pg5-mid3.png');
}
.pg5-m4 {
  position: relative;
  width: 5/2rem /* 80/16 */;
  height: 7.0625/2rem /* 113/16 */;
  margin-top: -.625rem /* 10/16 */;
  z-index: 3;
  .bg('./img/pg5-mid4.png');
}
.pg5-m5 {
  position: relative;
  width: 5.0625/2rem /* 81/16 */;
  height: 7.1875/2rem /* 115/16 */;
  margin-left: .625rem /* 10/16 */;
  margin-top: -.625rem /* 10/16 */;
  z-index: 2;
  .bg('./img/pg5-mid5.png');
}
.pg5-m6 {
  position: relative;
  width: 5/2rem /* 80/16 */;
  height: 7.0625/2rem /* 113/16 */;
  margin-top: -.625rem /* 10/16 */;
  .bg('./img/pg5-mid6.png');
}
.pg5-r1 {
  width: 13.625/2rem /* 218/16 */;
  height: 8.5/2rem /* 136/16 */;
  margin-top: 4.375rem /* 70/16 */;
  margin-right: .375rem /* 6/16 */;
  .bg('./img/pg5-right1.png');
}
.pg5-r2 {
  width: 13.5/2rem /* 216/16 */;
  height: 9.8125/2rem /* 157/16 */;
  margin-top: 1.625rem /* 26/16 */;
  right: .25rem /* 4/16 */;
  .bg('./img/pg5-right2.png');
}
.pg5-r3 {
  width: 13.6875/2rem /* 219/16 */;
  height: 14.6875/2rem /* 235/16 */;
  margin-top: .75rem /* 12/16 */;
  .bg('./img/pg5-right3.png');
}

.play {
  opacity: 1;
  .pg5-l1, .pg5-l2, .pg5-l3, .pg5-r1, .pg5-r2, .pg5-r3 {
    animation: slideIn .2s ease-in;
    animation-fill-mode: both;
  }
  .pg5-m1, .pg5-m2, .pg5-m3, .pg5-m4, .pg5-m5, .pg5-m6 {
    animation: slideIn .3s ease-in;
    animation-fill-mode: both;
  }
  .m-arrow1, .m-arrow2, .m-arrow3, .m-arrow4, .m-arrow5, .m-arrow6 {
    animation: slideIn .1s ease-in;
    animation-fill-mode: both;
  }
  .pg5-l1 {
    animation-delay: .4s;
  }
  .pg5-l2 {
    animation-delay: 1.6s;
  }
  .pg5-l3 {
    animation-delay: 2.8s;
  }
  .pg5-r1 {
    animation-delay: 1s;
  }
  .pg5-r2 {
    animation-delay: 2.2s;
  }
  .pg5-r3 {
    animation-delay: 3.4s;
  }
  .m-arrow1 {
    animation-delay: .3s;
  }
  .m-arrow2 {
    animation-delay: .9s;
  }
  .m-arrow3 {
    animation-delay: 1.5s;
  }
  .m-arrow4 {
    animation-delay: 2.1s;
  }
  .m-arrow5 {
    animation-delay: 2.7s;
  }
  .m-arrow6 {
    animation-delay: 3.3s;
  }
  .pg5-m2 {
    animation-delay: .6s;
  }
  .pg5-m3 {
    animation-delay: 1.2s;
  }
  .pg5-m4 {
    animation-delay: 1.8s;
  }
  .pg5-m5 {
    animation-delay: 2.4s;
  }
  .pg5-m6 {
    animation-delay: 3s;
  }
}
.pg5-article-text3 {
  margin: 1.25rem /* 20/16 */ auto;
  width: 36/2rem /* 576/16 */;
  height: 15.5625/2rem /* 249/16 */;
  .bg('./img/pg5-article-text3.png');
}
.pg5-fig1-wp {
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.pg5-fig1-table {
  width: 375px;
  height: 160px;
  background-image: url('./img/pg5-fig1-table.png');
  background-repeat: no-repeat;
}
.fig1-play {
  .pg5-fig1-table {
    animation: table1 2s steps(10);
    transition-property: background-position-x .01s linear 2s;
    background-position-x: -3375px;
  }
}
.pg5-fig1-footer {
  width: 15.625rem /* 250/16 */;
  height: 1.25rem /* 20/16 */;
  .bg('./img/pg5-fig1.png');
}
.pg5-article-text4 {
  margin: 1.25rem /* 20/16 */ auto;
  width: 35.25/2rem /* 564/16 */;
  height: 15.25/2rem /* 244/16 */;
  .bg('./img/pg5-article-text4.png');
}
.pg5-fig2-wp {
  position: relative;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  overflow: hidden;
}
.fig2-play {
  .pg5-fig2-table {
    animation: table2 2s steps(10);
    transition-property: background-position-x .01s linear 2s;
    background-position-x: -2493px;
  }
}
.pg5-fig3-table-wp {
  height: 434px;
  overflow: hidden;
  margin-bottom: 1.25rem /* 20/16 */;
}
.pg5-fig3-table {
  width: 298*2px;
  height: 434*2px;
  transform-origin: 50% 0;
  transform: scale(.5);
  background-repeat: no-repeat;
  background-image: url('./img/pg5-fig3-table.png');
}
.pg5-fig3-bottom {
  position: absolute;
  left: 50%;
  bottom: 0;
  width: 37.375/2rem /* 598/16 */;
  height: .75rem /* 12/16 */;
  .bg('./img/pg5-fig3-bottom.png');
  transform: translateX(-50%);
}
.fig3-play {
  .pg5-fig3-table {
    animation: table3 2s steps(10);
    transition-property: background-position-x .01s linear 2s;
    background-position-x: -2682*2px;
  }
}
.pg5-fig2-table {
  width: 277px;
  height: 87px;
  background-image: url('./img/pg5-fig2-table.png');
  background-repeat: no-repeat;
}
.pg5-fig2-footer {
  width: 36/2rem /* 576/16 */;
  height: 2.1875/2rem /* 35/16 */;
  .bg('./img/pg5-fig2.png');
}
.pg5-fig3-wp {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 auto;
  margin-top: 1.875rem /* 30/16 */;
}
.pg5-article-title2 {
  margin: .625rem /* 10/16 */ auto;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 333px;
  height: 81px;
  background-image: url('../page-one/img/title.png');
  background-repeat: no-repeat;
  background-position-x: 0;
  animation: titleAni 1s steps(11) infinite;
  img {
    width: 22.375/2.2rem /* 358/16 */;
    height: 2.6875/2.2rem /* 43/16 */;
  }
}
.pg5-article2 {
  box-sizing: border-box;
  margin: 0 auto;
  margin-bottom: 1.875rem /* 30/16 */;
  padding-top: 2.5rem /* 40/16 */;
  width: 42.8125/2rem /* 685/16 */;
  height: 72.8125/2rem /* 1165/16 */;
  .bg('./img/pg5-article2-bg.png');
}
.pg5-article2-part {
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0 1.625rem /* 26/16 */;
}
.pg5-article2-h5 {
  width: 15.5/2rem /* 248/16 */;
  height: 26.6875/2rem /* 427/16 */;
  .bg('./img/h5-2.png');
  a {
    display: inline-block;
    width: 100%;
    height: 100%;
  }
}
.pg5-article2-text1 {
  width: 15.1875/2rem /* 243/16 */;
  height: 29/2rem /* 464/16 */;
  .bg('./img/pg5-article2-text1.png');
}
.pg5-article2-text2 {
  margin: 1.875rem /* 30/16 */ auto;
  width: 36.5/2rem /* 584/16 */;
  height: 9.6875/2rem /* 155/16 */;
  .bg('./img/pg5-article2-text2.png');
}
.pg5-article2-text3 {
  margin: 0 auto;
  width: 21.25/2rem /* 340/16 */;
  height: 16.5/2rem /* 264/16 */;
  .bg('./img/pg5-article2-text3.png');
}
.bg-bottom {
  width: 23.4375rem /* 375/16 */;
  height: 43.1875/2rem /* 691/16 */;
  background: linear-gradient(to bottom, #012bad 1%, #5d46ac 40%, #a95ece 99%);
  .bg-bottom-inner {
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    height: 100%;
    .bg('../page-two/img/p2-bottom-bg.png');
  }
}
.btn-wp {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 6.25rem /* 100/16 */;
  height: 6.25rem /* 100/16 */;
  border-radius: 50%;
  background: linear-gradient(135deg, #ffcb04 1%, #faa711 50%, #fe9c21 100%);
  box-shadow: 0 0 6px 0 #5e50a3;
  transition: opacity .3s;
  &:active {
    opacity: .8;
  }
}
.icon-thumb {
  display: inline-block;
  width: 7.125/2rem /* 114/16 */;
  height: 7.25/2rem /* 116/16 */;
  margin-top: .375rem /* 6/16 */;
  .bg('../page-two/img/pg2-thumb.png');
}
.btn-num {
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
  color: #fff;
}
.btn-desc {
  margin: 1rem 0;
  color: #fff;
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
}
.btn-back {
  box-sizing: border-box;
  width: 9.375rem /* 150/16 */;
  border-radius: 1.875rem /* 30/16 */;
  font-size: .875rem /* 14/16 */;
  font-weight: bold;
  color: #fff;
  line-height: 2;
  text-align: center;
  border: 1px solid #fff;
  transition: opacity .3s;
  &:active {
    opacity: .8;
  }
}
@keyframes titleAni {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -3663px;
  }
}
@keyframes table1 {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -3750px;
  }
}
@keyframes table2 {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -2770px;
  }
}
@keyframes table3 {
  from {
    background-position-x: 0;
  }
  to {
    background-position-x: -2980*2px;
  }
}
@keyframes slideIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
</style>
